import { ABCampaigns } from "@/services/ABTestingService/types";

export const AB_CAMPAIGNS: ABCampaigns = {
  TRUSTPILOT_MODULE: { variant: "control", id: "24" },
};
